import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {NineToFive} from "../../NineToFive";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";


/**
 * Created by jonas on 2022-01-12.
 */

export class NoWin implements SimplePresentation {

    name:string = "NoWin";

    constructor() {
    }

    shouldRun():boolean {
        return NineToFive.model.data.mode == GameMode.NORMAL
            && NineToFive.model.data.nextMode == GameMode.NORMAL
            && NineToFive.model.winData.accumulatedWin == 0
            && Math.random() < 0.05;
    }

    private randomNoWin():string {
        return ["A", "B", "C"][Math.floor(Math.random() * 3)];
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline({
            onStart: () => {
                controller.setSkipCallback(() => tl.seek("End", false));
            },
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish()
            }
        })
            .add(NineToFive.transitionScreen.noWin(this.randomNoWin()))
            .add(() => {NineToFive.soundPlayer.playSound("winNo")}, '<')
            .add(() => {}, '>0.3')
            .addLabel("End");
    }
}
